module.exports = __webpack_public_path__ + "static/book-sentencePatterns1-177d46cc5e646ea4557b8faa67c3cf7a.png";